// angular import
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
// services import
import { ServerMapping } from './../../service/serverMapping.service';
// manager import
import { ModelsManager } from '../../manager/models.manager';
import { GrowlManager } from './../../manager/growl.manager';
import { DownloadManager } from '../../manager/download.manager';
// models import
import { OrderRequest } from './../../model/order/order_request.model';
import { OrderResponse } from './../../model/order/order_response.model';
import { Locale } from '../../service/locale.service';

@Injectable()
export class OrderService {

  private searching = false;
  private orders = [];

  constructor(private serverMapping:  ServerMapping,
              private growlManager:   GrowlManager,
              private http:           Http,
              private downloadManager: DownloadManager,
              private modelManager:   ModelsManager,
              private locale:         Locale) {}

  isSearching() { return this.searching; }

  getOrders() { return this.orders; }

/*   searchOrders() {
    if (this.searching === false) {
      this.searching = true;
      this.http.get(this.serverMapping.orderSearchURL +
        '?company_code=' + this.modelManager.order_request.company_code +
        '&order_number=' + this.modelManager.order_request.order_number +
        '&supplier_code=' + this.modelManager.order_request.supplier_code +
        '&language=' + this.modelManager.order_request.language).subscribe(
          (response) => {
            // store the response
            const data = response.json();
             // TODO : GROWL MANAGER
            if (this.growlManager.checkForErrorInResponse(data)) {
              this.growlManager.showMessagesByResponse(data);
            } else {
              this.orders = data.contained_bean;

              //if(this.orders && this.orders.length === 1) {
              //  this.orders[0].expanded = true;
              //}
            }

            this.searching = false;
          },
          (error) => {
            console.log('--------------------------------');
            console.log('!!!An error has been occurred!!!');
            console.log(error);
            console.log('--------------------------------');
          }
        );
    }
  } */
  searchOrders(order_number) {
    if (this.searching === false) {
      this.searching = true;
      this.http.get(this.serverMapping.orderSearchURL +
        '?company_code=' + this.modelManager.order_request.company_code +
        '&order_number=' + order_number +
        '&supplier_code=' + this.modelManager.order_request.supplier_code +
        '&language=' + this.locale.getPreferredLanguage()).subscribe(
          (response) => {
            // store the response
            const data = response.json();
             // TODO : GROWL MANAGER
            if (this.growlManager.checkForErrorInResponse(data)) {
              this.growlManager.showMessagesByResponse(data);
            } else {
              this.orders = data.contained_bean;
              /*
              if(this.orders && this.orders.length === 1) {
                this.orders[0].expanded = true;
              }*/
            }

            this.searching = false;
          },
          (error) => {
            console.log('--------------------------------');
            console.log('!!!An error has been occurred!!!');
            console.log(error);
            console.log('--------------------------------');
          }
        );
    }
  }

  printLabels(docNum, docPos, matCode) {
    this.http.get(this.serverMapping.orderPrintLabels +
      '?document_number=' + docNum +
      '&document_position=' + docPos +
      '&material_code=' + matCode).subscribe(
        (response) => {
          const data = response.json();
          if (!data.download) {
              this.growlManager.checkForErrors(data);
          }else {
              this.downloadManager.prepareDownload(data.download.data, data.download.file_name, data.download.mime_type);
          }
          console.log(data);
        },
        (error) => {
          console.log('--------------------------------');
          console.log('!!!An error has been occurred!!!');
          console.log(error);
          console.log('--------------------------------');
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/order/order.service.ts